import { useEffect, useState } from "react";
import { getBlogs } from "../api/api";
import "../App.css";

function Home() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    loadBlogs();
  }, []);

  const loadBlogs = async () => {
    const data = await getBlogs();
    setBlogs(data);
  };

  return (
    <div className="home-container">
      
      {/* Header */}
      <div className="home-header">
        <h1>Explore Blogs</h1>
        <p>Discover ideas, stories and knowledge from writers</p>
      </div>

      {/* Blog Grid */}
      <div className="blog-grid">
        {blogs.map((blog) => (
          <div className="blog-card" key={blog.id}>
            
            <div className="blog-content">
              <h2>{blog.title}</h2>
              <p>{blog.content.substring(0, 120)}...</p>
            </div>

            <div className="blog-footer">
              <span>By User #{blog.user_id}</span>
              <button className="read-btn">Read More</button>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;